<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col>
        <EditableMachineDetails :machine="Machine" :subjob="Subjob" @Update="val => updateMachineOnChildjob(val)">
        </EditableMachineDetails>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <machine-model-card :Machine="Machine" :MachineModel="Machine.MachineModel"
          @Update="val => updateMachineOnChildjob(val)">
        </machine-model-card>
        <machine-contract-card :machineId="Machine.Id">
        </machine-contract-card>
      </v-col>
      <v-divider vertical class="uplifted" />
      <v-col>
        <machine-forecasting-card :Machine="Machine">
        </machine-forecasting-card>
        <v-divider />
        <performance-card :id="Machine.Id">
        </performance-card>
      </v-col>
      <v-divider vertical class="uplifted" />
      <v-col>
        <SlottedCard :title="$t('servicesystem.common_objects.machine.machine_counters')" :icon="'mdi-counter'"
          :fontsize="'h4'">
          <template v-slot:content>
            <MachineCountersCardContent :machineId="Machine.Id">
            </MachineCountersCardContent>
          </template>
        </SlottedCard>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EditableMachineDetails from "@/views/job/newjob/cards/machines/EditableMachineDetails.vue";
import MachineContractCard from "@/views/job/newjob/cards/machines/MachineContractCard.vue";
import MachineCountersCardContent from "@/views/job/newjob/cards/machines/MachineCountersCardContent.vue";
import MachineForecastingCard from "@/views/job/newjob/cards/machines/MachineForecastingCard.vue";
import MachineModelCard from "@/views/job/newjob/cards/machines/MachineModelCard.vue";
import PerformanceCard from "@/views/job/newjob/cards/machines/PerformanceCard.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "MachineCard",
  props: {
    Machine: Object,
    Subjob: Object,
  },
  components: {
    EditableMachineDetails,
    PerformanceCard,
    MachineModelCard,
    MachineContractCard,
    MachineCountersCardContent,
    MachineForecastingCard,
    SlottedCard,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  methods: {
   

    updateMachineOnChildjob(updatedMachine) {
      var update = Object.assign({}, this.Subjob);
      update.Machine = Object.assign({}, updatedMachine);
      this.$store.dispatch("JobHub/JobUpdater/UpdateSubjob", update);
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.uplifted {
  z-index: 10;
}
</style>